import React, { useEffect, useState } from 'react';
import { SvgIcon, Typography, makeStyles } from '@material-ui/core';
import Layout from '../../components/Layout';
import fileApi from '../../api/files';
import { ReactComponent as CultureBookIcon } from '../../assets/icons/icon_culturebook.svg';

import FileList from './FileList';

const useStyles = makeStyles(theme => ({
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  title: {
    marginLeft: 10,
    fontWeight: 'bold',
    fontSize: `1.25rem`,
  },
  spacer: { width: `100%`, height: theme.spacing(3) },
  section: {
    borderRadius: 10,
    padding: theme.spacing(1),
    backgroundColor: `#ffffff`,
    border: `1px solid ${theme.palette.divider}`,
  },
  innerScroll: {
    flex: 1,
    maxHeight: `300px`,
    overflow: 'auto',
  },
}));

export default function CultureBookPage() {
  const classes = useStyles();
  // culture book
  const [books, setBooks] = useState(null);

  useEffect(() => {
    async function getCultureBooks() {
      const result = await fileApi.getFiles({ taxonomy: 'culture_book' });
      if (result.success) {
        setBooks(result.data.files);
      }
    }

    getCultureBooks();
  }, []);

  return (
    <Layout
      title={
        <div className={classes.titleWrapper}>
          <SvgIcon
            color="primary"
            component={CultureBookIcon}
            viewBox="0 0 48 48"
          />
          <Typography className={classes.title} variant="subtitle1">
            Culture Book
          </Typography>
        </div>
      }
    >
      {books && (
        <>
          {books.length === 0 ? (
            <Typography variant="caption">No Culture Book</Typography>
          ) : (
            <div className={classes.section}>
              <FileList files={books} />
            </div>
          )}
        </>
      )}
    </Layout>
  );
}
